import {useCallback, useEffect, useState} from 'react';

const useOnKeyDown = (targetKey, onKeyDown, onKeyUp) => {
  const [isKeyDown, setIsKeyDown] = useState(false);

  const onKeyDownLocal = useCallback(
    e => {
      if (e.keyCode !== targetKey) {
        return;
      }
      setIsKeyDown(true);

      if (typeof onKeyDown !== 'function') {
        return;
      }
      onKeyDown(e);
    },
    [onKeyDown, targetKey]
  );
  const onKeyUpLocal = useCallback(
    e => {
      if (e.keyCode !== targetKey) {
        return;
      }
      setIsKeyDown(false);

      if (typeof onKeyUp !== 'function') {
        return;
      }
      onKeyUp(e);
    },
    [onKeyUp, targetKey]
  );

  useEffect(() => {
    window.addEventListener('keydown', onKeyDownLocal);
    window.addEventListener('keyup', onKeyUpLocal);

    return () => {
      window.removeEventListener('keydown', onKeyDownLocal);
      window.removeEventListener('keyup', onKeyUpLocal);
    };
  }, [onKeyDownLocal, onKeyUpLocal]);

  return isKeyDown;
};

export default useOnKeyDown;
